function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Logo + LogoType");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.52,152.3H8.14V110.62H2.52v-4.47H18.43v4.47H12.6V152.3h5.83v4.25H2.52Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.06,152.3h5.62V138.82a6,6,0,0,0-1.55-3.66,5.86,5.86,0,0,0-4.28-1.72,10.71,10.71,0,0,0-3.93.72,11.62,11.62,0,0,0-3.27,1.93A9,9,0,0,0,34.38,139a8.26,8.26,0,0,0-.83,3.69v9.61h5v4.25h-15V152.3h5.55V133.94h-5v-4.39H32.9l.08,1.59q.06,1.5.18,2.7t.18,2.7A11.7,11.7,0,0,1,38,131,13,13,0,0,1,45.14,129a9.06,9.06,0,0,1,6.48,2.23A8.06,8.06,0,0,1,54.14,137V152.3H59v4.25h-15Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.12,148.56v3.18a6.25,6.25,0,0,0,2.32.78,20.66,20.66,0,0,0,2.61.14,5.29,5.29,0,0,0,1.06-.14,4.45,4.45,0,0,0,1.41-.57,4.28,4.28,0,0,0,1.27-1.14,3.51,3.51,0,0,0,.62-1.93,2.89,2.89,0,0,0-.84-2.39,7.21,7.21,0,0,0-2.28-1.35c-.91-.36-1.92-.69-3-1a13.89,13.89,0,0,1-3-1.26,6.76,6.76,0,0,1-2.36-2.19,6.93,6.93,0,0,1-.94-3.86,7.43,7.43,0,0,1,.79-3.56,7.35,7.35,0,0,1,2-2.41,8.31,8.31,0,0,1,2.66-1.37,9.45,9.45,0,0,1,2.74-.43,12.47,12.47,0,0,1,1.47.11,14.85,14.85,0,0,1,2.09.39,11.53,11.53,0,0,1,2.2.83,6.5,6.5,0,0,1,1.87,1.4v5.76h-4v-3.26a4.56,4.56,0,0,0-1.85-.63,14.13,14.13,0,0,0-1.57-.14,4.82,4.82,0,0,0-2.87.85,2.67,2.67,0,0,0-1,2.61,2.6,2.6,0,0,0,1.12,1.91,11.46,11.46,0,0,0,2.35,1.27c.92.37,1.9.76,2.93,1.14a12.68,12.68,0,0,1,2.9,1.51A8.22,8.22,0,0,1,82,145.18a6.72,6.72,0,0,1,.91,3.67,8.86,8.86,0,0,1-.43,2.52A8.36,8.36,0,0,1,81,154.1a7.62,7.62,0,0,1-2.74,2.16,9.72,9.72,0,0,1-4.39.87,18.53,18.53,0,0,1-2.23-.15,16.27,16.27,0,0,1-2.41-.46,14,14,0,0,1-2.31-.87,5.92,5.92,0,0,1-1.83-1.33v-5.76Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.62,152.3H93V134H87.62v-4.47h9.79V152.3h5.19v4.25h-15Zm4.54-32.72a2.89,2.89,0,0,1,.93-2.17,3.08,3.08,0,0,1,2.16-.89,2.87,2.87,0,0,1,2.06.89,2.94,2.94,0,0,1,.9,2.17,2.79,2.79,0,0,1-.9,2.17,3,3,0,0,1-2.06.82,3.19,3.19,0,0,1-2.16-.82A2.74,2.74,0,0,1,92.16,119.58Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M132.26,154.39V152a5.22,5.22,0,0,1-1.11,1.58,10.28,10.28,0,0,1-2.16,1.66,14,14,0,0,1-3.1,1.33,13.36,13.36,0,0,1-3.92.54,14.26,14.26,0,0,1-5.66-1.12,13.73,13.73,0,0,1-4.53-3.06,14.86,14.86,0,0,1-3-4.5,13.86,13.86,0,0,1,0-10.87,15.11,15.11,0,0,1,3-4.5,13.88,13.88,0,0,1,4.53-3.06A14.44,14.44,0,0,1,122,128.9a12.25,12.25,0,0,1,3.67.54,14.09,14.09,0,0,1,3.09,1.37,11,11,0,0,1,2.27,1.77,7.08,7.08,0,0,1,1.26,1.65c-.09-.67-.18-1.33-.25-2s-.16-1.36-.25-2.08V107h-4.9v-4.47h9.36V152.3h5.4v4.25h-9.36ZM112.1,143a9.44,9.44,0,0,0,.76,3.82,9.61,9.61,0,0,0,2.06,3,9.37,9.37,0,0,0,3.11,2,10.52,10.52,0,0,0,7.8,0,9.37,9.37,0,0,0,3.11-2,9.61,9.61,0,0,0,2.06-3,9.76,9.76,0,0,0-2.06-10.68,9.55,9.55,0,0,0-3.11-2,10.52,10.52,0,0,0-7.8,0,9.55,9.55,0,0,0-3.11,2A9.68,9.68,0,0,0,112.1,143Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M173.45,140l-21,8a9.25,9.25,0,0,0,3.42,3.41,9.82,9.82,0,0,0,5,1.27,9.32,9.32,0,0,0,3.63-.7,9,9,0,0,0,2.92-1.89l1.33,1.62q.69.84,1.41,1.62a14.09,14.09,0,0,1-4.22,2.81,12.71,12.71,0,0,1-5.07,1,13.8,13.8,0,0,1-5.55-1.12,14.67,14.67,0,0,1-4.53-3,13.9,13.9,0,0,1-3.06-4.47,13.46,13.46,0,0,1-1.12-5.5,13.64,13.64,0,0,1,1.12-5.48,14,14,0,0,1,3.06-4.5,14.85,14.85,0,0,1,4.53-3,14,14,0,0,1,5.55-1.12,10.83,10.83,0,0,1,4.21.83,12.5,12.5,0,0,1,3.6,2.31,15.27,15.27,0,0,1,2.84,3.52A18,18,0,0,1,173.45,140Zm-12.59-6.62a9.93,9.93,0,0,0-4.14.86,9.5,9.5,0,0,0-5.16,5.57,9,9,0,0,0-.43,3.94c2.76-1.06,5.52-2.1,8.28-3.14s5.52-2.07,8.28-3.13a9,9,0,0,0-2.87-3A7.28,7.28,0,0,0,160.86,133.37Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M200.37,106.15h15.92v4.47h-5.37q3.9,9,7.74,18t7.74,18l.65,2.22a102.18,102.18,0,0,1,5.22-13.64q3.14-6.74,5.94-13.43c-.82-1.85-1.63-3.71-2.45-5.58s-1.63-3.76-2.45-5.65H227v-4.47h15.91v4.47h-5.14q3.9,9,7.7,18t7.77,18l.65,2.22.66-2.22q3.92-9,7.73-18T270,110.62h-4.72v-4.47h15.84v4.47h-6.66l-10.29,24.12q-5.11,12-10.23,24.12l-12.74-30-.72-2.23c-.82,2.69-1.76,5.39-2.84,8.1s-2.22,5.43-3.42,8.14-2.42,5.41-3.64,8.1-2.39,5.32-3.49,7.92q-5.19-12.13-10.3-24.12l-10.29-24.12h-6.09Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M302,140l-21,8a9.25,9.25,0,0,0,3.42,3.41,9.82,9.82,0,0,0,5,1.27,9.32,9.32,0,0,0,3.63-.7,9,9,0,0,0,2.92-1.89l1.33,1.62q.69.84,1.41,1.62a14.09,14.09,0,0,1-4.22,2.81,12.71,12.71,0,0,1-5.07,1A13.8,13.8,0,0,1,284,156a14.67,14.67,0,0,1-4.53-3,13.9,13.9,0,0,1-3.06-4.47,13.46,13.46,0,0,1-1.12-5.5,13.64,13.64,0,0,1,1.12-5.48,14,14,0,0,1,3.06-4.5,14.85,14.85,0,0,1,4.53-3,14,14,0,0,1,5.55-1.12,10.83,10.83,0,0,1,4.21.83,12.5,12.5,0,0,1,3.6,2.31,15.27,15.27,0,0,1,2.84,3.52A18,18,0,0,1,302,140Zm-12.59-6.62a9.93,9.93,0,0,0-4.14.86,9.5,9.5,0,0,0-5.16,5.57,9,9,0,0,0-.43,3.94c2.76-1.06,5.52-2.1,8.28-3.14s5.52-2.07,8.28-3.13a9,9,0,0,0-2.87-3A7.28,7.28,0,0,0,289.45,133.37Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M307.29,152.3h5.4V107H307.8v-4.47h9.36V152.3h5.11v4.25h-15Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M327.31,152.3h5.4V107h-4.9v-4.47h9.36V152.3h5.11v4.25h-15Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M347.32,152.3h5.4V107h-4.89v-4.47h9.36v28.8c-.1.53-.18,1-.25,1.48s-.16.92-.26,1.4a5.36,5.36,0,0,1,1.23-1.65,12.1,12.1,0,0,1,2.3-1.77,14.18,14.18,0,0,1,3.1-1.37,12.48,12.48,0,0,1,3.74-.54,14.13,14.13,0,0,1,5.62,1.12,14,14,0,0,1,4.5,3.06,14.89,14.89,0,0,1,3,4.5,13.75,13.75,0,0,1,0,10.87,14.65,14.65,0,0,1-3,4.5,13.81,13.81,0,0,1-4.5,3.06,14,14,0,0,1-5.62,1.12,13.32,13.32,0,0,1-3.92-.54,14,14,0,0,1-3.1-1.33,10.8,10.8,0,0,1-2.19-1.66,5.16,5.16,0,0,1-1.16-1.58v4.53h-9.36ZM376.84,143a10,10,0,0,0-.72-3.79,9,9,0,0,0-2-3.07,9.65,9.65,0,0,0-3.11-2,10.07,10.07,0,0,0-3.9-.75,10.3,10.3,0,0,0-4,.75,9.5,9.5,0,0,0-3.1,2,9.26,9.26,0,0,0-2.06,3.07A9.67,9.67,0,0,0,360,149.88a9.32,9.32,0,0,0,3.1,2,10.12,10.12,0,0,0,4,.75,9.89,9.89,0,0,0,3.9-.75,9.47,9.47,0,0,0,3.11-2,9.19,9.19,0,0,0,2-3A10,10,0,0,0,376.84,143Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M413.13,140l-20.95,8a9.1,9.1,0,0,0,3.42,3.41,9.76,9.76,0,0,0,5,1.27,9.37,9.37,0,0,0,3.64-.7,9,9,0,0,0,2.92-1.89c.43.53.87,1.07,1.33,1.62s.92,1.1,1.4,1.62a14,14,0,0,1-4.21,2.81,12.73,12.73,0,0,1-5.08,1,13.75,13.75,0,0,1-5.54-1.12,14.71,14.71,0,0,1-4.54-3,14.22,14.22,0,0,1-3.06-4.47,13.62,13.62,0,0,1-1.11-5.5,13.8,13.8,0,0,1,1.11-5.48,14.35,14.35,0,0,1,3.06-4.5,14.89,14.89,0,0,1,4.54-3,13.92,13.92,0,0,1,5.54-1.12,10.83,10.83,0,0,1,4.21.83,12.68,12.68,0,0,1,3.61,2.31,15.54,15.54,0,0,1,2.84,3.52A17.93,17.93,0,0,1,413.13,140Zm-12.59-6.62a9.93,9.93,0,0,0-4.14.86,9.54,9.54,0,0,0-3.19,2.29,9.34,9.34,0,0,0-2,3.28,9,9,0,0,0-.44,3.94c2.76-1.06,5.52-2.1,8.28-3.14s5.52-2.07,8.28-3.13a8.86,8.86,0,0,0-2.87-3A7.23,7.23,0,0,0,400.54,133.37Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M418.39,152.3h5.32V134h-5.32v-4.47h9.79V152.3h5.18v4.25h-15Zm4.53-32.72a2.86,2.86,0,0,1,.94-2.17,3,3,0,0,1,2.16-.89,2.85,2.85,0,0,1,2.05.89,2.94,2.94,0,0,1,.9,2.17,2.79,2.79,0,0,1-.9,2.17,2.94,2.94,0,0,1-2.05.82,3.15,3.15,0,0,1-2.16-.82A2.72,2.72,0,0,1,422.92,119.58Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M458.92,152.3h5.62V138.82a6,6,0,0,0-1.55-3.66,5.88,5.88,0,0,0-4.28-1.72,10.68,10.68,0,0,0-3.93.72,11.62,11.62,0,0,0-3.27,1.93,9,9,0,0,0-2.27,2.91,8.26,8.26,0,0,0-.83,3.69v9.61h5v4.25h-15V152.3H444V133.94h-5v-4.39h8.78l.07,1.59q.07,1.5.18,2.7c.08.79.14,1.69.19,2.7a11.7,11.7,0,0,1,4.64-5.51A13,13,0,0,1,460,129a9.06,9.06,0,0,1,6.48,2.23A8.06,8.06,0,0,1,469,137V152.3h4.9v4.25h-15Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M503.85,129.55H513V134h-5.47v26a15.47,15.47,0,0,1-1.08,5.88,14,14,0,0,1-3,4.59,13.7,13.7,0,0,1-4.46,3,14,14,0,0,1-5.44,1.07,17.42,17.42,0,0,1-6.22-1.29,18.34,18.34,0,0,1-5.08-3l3-3.6a12.46,12.46,0,0,0,3.68,2.48,10.71,10.71,0,0,0,4.46,1,9.12,9.12,0,0,0,3.78-.8,9.24,9.24,0,0,0,3.06-2.21,10.76,10.76,0,0,0,2.05-3.34,11.4,11.4,0,0,0,.76-4.25v-5.08a9.42,9.42,0,0,0,.21-1.16,9.47,9.47,0,0,1,.22-1.16,7.68,7.68,0,0,1-1.33,1.69,9.72,9.72,0,0,1-2.2,1.62,13.41,13.41,0,0,1-3,1.19,13.88,13.88,0,0,1-3.7.47,14.44,14.44,0,0,1-5.66-1.12,14.1,14.1,0,0,1-4.53-3,14.66,14.66,0,0,1-3-4.43,13.25,13.25,0,0,1-1.11-5.4,13.54,13.54,0,0,1,1.11-5.44,15.11,15.11,0,0,1,3-4.5,14.45,14.45,0,0,1,4.53-3.09,14,14,0,0,1,5.66-1.16,12.26,12.26,0,0,1,3.78.58,14.1,14.1,0,0,1,3.13,1.44,12.49,12.49,0,0,1,2.27,1.8,4.54,4.54,0,0,1,1.11,1.66c0-.77,0-1.56.11-2.38S503.8,130.37,503.85,129.55ZM483.4,143a9.36,9.36,0,0,0,.76,3.81,9.39,9.39,0,0,0,5.17,5.06,10.65,10.65,0,0,0,7.8,0,9.39,9.39,0,0,0,5.17-5.06,9.83,9.83,0,0,0,0-7.58,9.37,9.37,0,0,0-2.06-3.06,9.52,9.52,0,0,0-3.11-2,10.52,10.52,0,0,0-7.8,0,9.52,9.52,0,0,0-3.11,2A9.63,9.63,0,0,0,483.4,143Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M245.38.54h2l10.44,24.15L268.35.54h2L258.82,26.86l15.42,35.31L301.29,0h2L275.24,64.44h-2L257.91,29.13,242.57,64.44h-2L212.53,0h2l27,62.17,15.34-35.31Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M231.57,17.28h1.7V4.63h-1.7V3.28h4.82V4.63h-1.77V17.28h1.77v1.29h-4.82Z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M272.72,17.28h1.84V4.63h-1.84V3.28h2.45l11,12.41.42.57-.07-.7V4.63h-1.61V3.28h4.82V4.63h-1.85V19.27L276.26,6.36l-.39-.55,0,.68V17.28h1.66v1.29h-4.85Z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-1",
  x1: 312.25,
  y1: 32.05,
  x2: 511.25,
  y2: 32.05
});

var _ref23 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-1",
  x1: 0.25,
  y1: 32.05,
  x2: 199.25,
  y2: 32.05
});

var _ref24 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-1",
  x1: 314.25,
  y1: 223.05,
  x2: 513.25,
  y2: 223.05
});

var _ref25 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-1",
  x1: 2.25,
  y1: 223.05,
  x2: 201.25,
  y2: 223.05
});

var SvgLogoLogoType = function SvgLogoLogoType(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 515.51 224.05",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoLogoType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo + LogoType.892d78c3.svg";
export { ForwardRef as ReactComponent };